module.exports = __webpack_public_path__ + "static/media/graph.021cd354.png";